import styled from "styled-components";
import Td from "./Td";
import Th from "./Th";

const Table = styled.table`
  max-width: 100%;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 1rem;

  ${Td}:first-child, ${Th}:first-child {
    border-left: 1px solid ${({ theme }) => theme.colors.gray200};

    @media screen and (max-width: 900px) {
      white-space: initial;
    }
  }

  ${Td}:last-child, ${Th}:last-child {
    border-right: 1px solid ${({ theme }) => theme.colors.gray200};
  }
`;

export default Table;
